<template>
  <div class="login">
    <van-nav-bar title="游客自主退票" />
    <div class="page-body">
      <img class="login-bg" src="@/assets/login_bg.png" alt="登录背景" />
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          name="username"
          placeholder="请输入您的姓名"
          :rules="[{ required: true }]"
        >
          <template #left-icon>
            <svg class="icon icon-name" aria-hidden="true">
              <use xlink:href="#icon-zhanghu"></use>
            </svg>
          </template>
        </van-field>
        <van-field
          v-model="id"
          left-icon="smile-o"
          name="id"
          placeholder="请输身份证号码"
          :rules="[{ required: true }]"
        >
          <template #left-icon>
            <svg class="icon icon-id" aria-hidden="true">
              <use xlink:href="#icon-shenfenzheng"></use>
            </svg>
          </template>
        </van-field>
        <div class="form-action">
          <van-button
            class="form-btn"
            round
            block
            type="info"
            native-type="submit"
          >
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Toast } from '@sdi/fish';
import { KEY } from '@/consts';

export default {
  name: 'Login',
  components: {},
  data: () => ({
    username: '',
    id: ''
  }),
  mounted() {
    this.init();
  },
  watch: {
    $route: 'init'
  },
  methods: {
    ...mapActions(['login']),
    init() {
      if (this.$store.getters.user) {
        this.username = this.$store.getters.user.username;
        this.id = this.$store.getters.user.id;
      }
    },
    onSubmit() {
      if (!this.$route.query[KEY]) {
        Toast('参数错误，请重新扫码进入');
        return;
      }
      this.login({
        username: this.username.trim(),
        id: this.id.trim(),
        corpCode: this.$route.query[KEY].trim()
      });
      this.$router.push({
        name: 'orderList'
      });
    }
  }
};
</script>

<style lang="less">
.page-body {
  margin: 0 47.5px;

  .van-field__control {
    font-size: 15px;
  }
}
.login-bg {
  width: 209px;
  height: 131px;
  margin: 20px auto 40px;
  display: block;
}
.icon-name {
  width: 15px;
  height: 16px;
}
.icon-id {
  width: 17px;
  height: 14.5px;
}
</style>
